export const staticHomePageData = {
  planUsps: {
    "ReAssure2.0": {
      heading: "Niva Bupa’s bestselling Health Plan",
      subHeading:
        "Our bestselling health insurance plan provides extensive coverage and benefits for all your healthcare needs.",
      premium: "7,326",
      sumInsured: "₹ 5,00,000",
      mobilePlanDescription: "Family Health Insurance Plan",
      usps: [
        "Pay premium as per your entry age (till a claim is paid)",
        "Carry forward unused base sum insured up to 10 times of base cover",
        "Use and get back your base coverage, over and above the balance. Unlimited times, Forever",
        "Up to 30% discount over and above the on renewals",
      ],
      link: "https://www.nivabupa.com/family-health-insurance-plans/reassurev2-insurance.html",
      img: "/ethinos-home-page/images/product/reassure2.0-image.jpg",
      customerCount: 10000,
      superScript: 3,
    },
    "Health Premia": {
      heading:
        "Niva Bupa’s most comprehensive Premium & NRI Health Plan",
      subHeading:
        "Our premium health insurance plan, designed for premium customers and NRIs, includes in-built travel insurance and comprehensive coverage benefits tailored to their needs.",
      premium: "11,572",
      sumInsured: "5,00,000",
      mobilePlanDescription: "Family Health Insurance Plan",
      usps: [
        "Pay premium as per your entry age (till a claim is paid)",
        "Carry forward unused base sum insured up to 10 times of base cover",
        "Use and get back your base coverage, over and above the balance. Unlimited times, Forever",
        "Up to 30% discount over and above the on renewals",
      ],
      link: "https://www.nivabupa.com/family-health-insurance-plans/health-premia-family-floater.html",
      img: "/ethinos-home-page/images/product/health-premia-image.jpg",
      customerCount: 10000,
      superScript: 3,
    },
    "HEALTH RECHARGE": {
      heading: "Niva Bupa’s most affordable Health Plan",
      subHeading:
        "Enhance your family's health insurance cover with this super top-up plan",
      premium: "956",
      sumInsured: "90,00,000",
      mobilePlanDescription: "Family Health Insurance Plan",
      usps: [
        "Coverage Up to INR 95 Lac",
        "Unlimited tele / online consultations",
        "Pre and Post Hospitalisation expenses: Covered up to Sum Insured",
        "All Day-care treatment covered",
      ],
      link: "https://www.nivabupa.com/family-health-insurance-plans/health-recharge-family-floater.html",
      img: "/ethinos-home-page/images/product/health-premia-image.jpg",
      customerCount: 10000,
      superScript: 3,
    },
    Aspire: {
      heading:
        "Niva Bupa’s Health Plan for young individuals and married couples",
      subHeading:
        "Our specialized maternity health insurance plan offers comprehensive coverage for pregnancy, IVF and more.",
      premium: "8,633",
      sumInsured: "5,00,000",
      mobilePlanDescription: "Family Health Insurance Plan",
      usps: [
        "Covers expenses around maternity, IVF, adoption, surrogacy and more.",
        "Pay premium as per your entry age (till a claim is paid)",
        "Carry forward the balance sum insured up to 10X.",
        "Accumulate cashback on every claim-free year. Pay for premiums, deductible, co-payment, and OPD.",
      ],
      link: "https://www.nivabupa.com/health-insurance-plan/aspire",
      img: "/ethinos-home-page/images/product/aspire-image.jpg",
      customerCount: 10000,
      superScript: 3,
    },
    "Senior First": {
      heading: "Niva Bupa’s Health Plan for senior citizens",
      subHeading:
        "Our specialized senior citizens health insurance plan tailored to meet their unique healthcare needs.",
      premium: "16,125",
      sumInsured: "5,00,000",
      mobilePlanDescription: "Family Health Insurance Plan",
      usps: [
        "Use and get back your base coverage, over and above the balance. Unlimited times",
        "Avail Annual Health-check up from Day 1",
        "Coverage even for non-payable items like gloves etc",
        "No mandatory Pre-Issuance Medical test",
      ],
      link: "https://www.nivabupa.com/family-health-insurance-plans/senior-citizen-family-floater.html",
      img: "/ethinos-home-page/images/product/senior-first-image.jpg",
      customerCount: 10000,
      superScript: 3,
    },
    "SmartHealth + Disease Management Add-On": {
      heading: "Day 1 Coverage for Diabetes & Hypertension",
      subHeading:
        "Get immediate coverage for diabetes and hypertension from day one with Niva Bupa's specialized health plan.",
      premium: "16,125",
      sumInsured: "5,00,000",
      mobilePlanDescription: "Family Health Insurance Plan",
      usps: [
        "No waiting period for pre-existing diabetes and hypertension",
        "No extra premium for pre-existing diabetes and hypertension",
        "Up to 20% off on renewal premium based on quarterly test results",
        "Diagnostic tests covered up to INR 3,000 per year",
      ],
      link: "https://www.nivabupa.com/smart-health-plus-disease-management.html",
      img: "/ethinos-home-page/images/product/smart-health-image.jpg",
      customerCount: 10000,
      superScript: 3,
    },
  },
  articles: [
    {
      title: "Need, Significance and Benefits of Having a Health Plan",
      category: "Health Insurance",
      time: "5 min read",
      img: "/ethinos-home-page/images/articles/blog1.jpg",
      link: "https://www.nivabupa.com/health-insurance-articles/significance-and-benefits-of-having-a-health-plan.html",
    },
    {
      title:
        "Essential Aspects To Consider Before Deciding On A Health Insurance",
      category: "Health Insurance",
      time: "5 min read",
      img: "/ethinos-home-page/images/articles/blog2.jpg",
      link: "https://www.nivabupa.com/health-insurance-articles/essential-aspects-to-consider-before-deciding-on-a-health-insurance.html",
    },
    {
      title: "A Guide to Choose the Right Health Insurance Plan",
      category: "Health Insurance",
      time: "5 min read",
      img: "/ethinos-home-page/images/articles/blog3.jpg",
      link: "https://www.nivabupa.com/health-insurance-articles/insurance-schemes-in-india.html",
    },
    {
      title: "Health Insurance Migration: A Detailed Guide",
      category: "Health Insurance",
      time: "5 min read",
      img: "/ethinos-home-page/images/articles/blog4.jpg",
      link: "https://www.nivabupa.com/health-insurance-articles/health-insurance-migration.html",
    },
    {
      title:
        "Advantages and Disadvantages of Corporate Health Insurance plan",
      category: "Health Insurance",
      time: "5 min read",
      img: "/ethinos-home-page/images/articles/blog5.jpg",
      link: "https://www.nivabupa.com/health-insurance-articles/corporate-health-insurance-advantages-and-disadvantages.html",
    },
  ],
  headerList: [
    {
      name: "Plans",
      iconPath: "/ethinos-home-page/svgs/icons/taskIcon_Plans.svg",
      chevronFlag: true,
      link: null,
    },
    {
      name: "Claims",
      iconPath: "/ethinos-home-page/svgs/icons/checkIcon_Claims.svg",
      chevronFlag: false,
      link: "https://transactions.nivabupa.com/claims/pages/health-claim.aspx",
    },
    {
      name: "Renewals",
      iconPath:
        "/ethinos-home-page/svgs/icons/recycleIcon_Renewals.svg",
      chevronFlag: false,
      link: "https://transactions.nivabupa.com/renewal/renewpolicies.aspx",
    },
    {
      name: "Resources",
      iconPath: "/ethinos-home-page/svgs/icons/sparkIcon_Resources.svg",
      chevronFlag: false,
      link: "https://www.nivabupa.com/health-insurance-articles.html",
    },
    {
      name: "Customer Support",
      iconPath: "/ethinos-home-page/svgs/icons/headsetIcon_Support.svg",
      chevronFlag: true,
      link: null,
    },
    {
      name: "Become an Agent",
      iconPath: "/ethinos-home-page/svgs/icons/shieldIcons_Agents.svg",
      chevronFlag: false,
      link: "https://www.nivabupa.com/become-an-agent-portal.html",
    },
  ],
  headerPopover: {
    Plans: [
      {
        category: "Health Insurance",
        categoryLink:
          "https://www.nivabupa.com/health-insurance-plans.html",
        subCategories: [
          {
            text: "For me",
            link: "https://www.nivabupa.com/individual-health-insurance-plans.html",
          },
          {
            text: "For Family",
            link: "https://www.nivabupa.com/family-health-insurance-plans.html",
          },
          {
            text: "For NRIs",
            link: "https://www.nivabupa.com/family-health-insurance-plans/health-premia-family-floater.html",
          },
          {
            text: "For Senior Citizens",
            link: "https://www.nivabupa.com/family-health-insurance-plans/senior-citizen-family-floater.html",
          },
          {
            text: "Personal Accident",
            link: "https://www.nivabupa.com/personal-accident-insurance.html",
          },
          {
            text: "View All",
            link: "https://www.nivabupa.com/health-insurance-plans.html",
          },
        ],
      },
      {
        category: "Travel Insurance",
        categoryLink: "https://www.nivabupa.com/travel-insurance.html",
        subCategories: [
          {
            text: "For international travel",
            link: "https://www.nivabupa.com/travel-insurance.html",
          },
          {
            text: "Travel for study abroad",
            link: "https://www.nivabupa.com/travel-insurance.html",
          },
        ],
      },
      {
        category: "Corporate Insurance",
        categoryLink:
          "https://www.nivabupa.com/corporate-group-health-insurance.html",
        subCategories: [
          {
            text: "Group Mediclaim",
            link: "https://www.nivabupa.com/corporate-group-health-insurance.html",
          },
          {
            text: "Group Travel",
            link: "https://www.nivabupa.com/corporate-group-health-insurance.html",
          },
          {
            text: "Group Personal Accident",
            link: "https://www.nivabupa.com/corporate-group-health-insurance.html",
          },
        ],
      },
    ],
    "Customer Support": [
      {
        category: "",
        subCategories: [
          {
            text: "24*7 Support (InstaAssist)",
            link: "https://rules.nivabupa.com/customer-service/",
          },
          {
            text: "Customer Helpline: 1860-500-8888",
            link: "tel:1860-500-8888",
          },
          {
            text: "Plan Recommendation",
            link: "https://www.nivabupa.com/health-insurance-plans/get-quote.html",
          },
          // {
          //   text: "For New Policy: 1800-309-3333",
          //   link: "tel:1800-309-3333",
          // },
        ],
      },
    ],
    Support: {},
  },
  planCategories: [
    {
      category: "Best Selling Plan",
      name: "ReAssure2.0",
    },
    {
      category: "Maternity Plan",
      name: "Aspire",
    },
    {
      category: "Senior Citizen Plan",
      name: "Senior First",
    },
    {
      category: "Premium & NRI Plan",
      name: "Health Premia",
    },
    {
      category: "Diabetes & Hypertension Plan",
      name: "SmartHealth + Disease Management",
    },
  ],
  plansMapping: {
    "Best Selling Plan": "ReAssure2.0",
    "Maternity Plan": "Aspire",
    "Senior Citizen Plan": "Senior First",
    "Premium & NRI Plan": "Health Premia",
    "Diabetes & Hypertension Plan":
      "SmartHealth + Disease Management Add-On",
  },
  customerTestimonialData: [
    {
      imgUrl: "/ethinos-home-page/images/testimonial/vippan-kapur.jpg",
      customerName: "Vippan Kapur",
      policyName: "ReAssure 2.0",
      testimonial:
        "It is unbelievable how Niva Bupa claim team came to my aid, Monday to Sunday no day off.",
      videoLink:
        "https://www.youtube.com/embed/GQutOqjrMBw?autoplay=1&mute=1",
    },
    {
      imgUrl:
        "/ethinos-home-page/images/testimonial/meenakshi-khanna.jpg",
      customerName: "Meenakshi Khanna",
      policyName: "ReAssure 2.0",
      testimonial:
        "Within few hours we got the claim number and in the next three days the amount was reflected in our bank account.",
      videoLink:
        "https://www.youtube.com/embed/wsgdHGctOi8?autoplay=1&mute=1",
    },
    {
      imgUrl: "/ethinos-home-page/images/testimonial/vijay-kapoor.jpg",
      customerName: "Vijay Kapoor",
      policyName: "ReAssure 2.0",
      testimonial:
        "With the help of Niva Bupa Health Insurance, I was able to get my son treated without worrying about the high medical cost.",
      videoLink:
        "https://www.youtube.com/embed/0OU4RLy8hdM?autoplay=1&mute=1",
    },
    {
      imgUrl: "/ethinos-home-page/images/testimonial/dvijay-chadha.jpg",
      customerName: "Dvijay Chadha",
      policyName: "ReAssure 2.0",
      testimonial:
        "Whenever we have filed for a claim with Niva Bupa, the process was very smooth and people were very helpful.",
      videoLink:
        "https://www.youtube.com/embed/pNq1CUJYYhs?autoplay=1&mute=1",
    },
    {
      imgUrl: "/ethinos-home-page/images/testimonial/parveen-singh.jpg",
      customerName: "Praveen Singh",
      policyName: "ReAssure 2.0",
      testimonial:
        "The Niva Bupa team was extremely helpful, be it day or night, someone was always available.",
      videoLink:
        "https://www.youtube.com/embed/1gE-aBJRrC4?autoplay=1&mute=1",
    },
  ],
  downloadAppSection: {
    downloadImgUpperNumber: "12L+",
    downloadImgUpperText: "Downloads",
    downloadImgLowerNumber: "52K+",
    downloadImgLowerText: "Reviews",
  },
  otherTexts: {
    secondSectionText:
      "Niva Bupa health insurance plans empower you to claim your life to the fullest by giving you seamless access to the best of healthcare",
  },
  footerDisclaimers: [
    {
      superscript: "",
      text: "Insurance is a subject matter of solicitation. Niva Bupa Health Insurance Company Limited (formerly known as Max Bupa Health Insurance Company Limited) (IRDAI Registration Number 145, Category:Health), 'Bupa' and 'HEARTBEAT' logo are registered trademarks of their respective owners and are being used by Niva Bupa Health Insurance Company Limited (formerly known as Max Bupa Health Insurance Company Limited) under license. CIN: L66000DL2008PLC182918",
    },
    {
      superscript: "1",
      text: "Since Inception refers to claim data from 2010 till December 2023",
    },
    {
      superscript: "2",
      text: "Niva Bupa processes pre-authorisation requests within 30 minutes for all active policies, subject to receiving all documents and information(s) up to Niva Bupa’s satisfaction. The above commitment does not include pre-authorisation settlement at the time of discharge or system outage.",
    },
    {
      superscript: "",
      text: "The premium is including taxes for a plan with INR 10L deductible, for a 25-year-old individual living in Delhi.",
    },
    {
      superscript: "",
      text: "The premium is including taxes and for Gold+ Variant, for a 25-year-old individual living in Delhi.",
    },
    {
      superscript: "",
      text: "The premium is including taxes and for Silver Variant, for a 25-year-old individual living in Delhi.",
    },
    {
      superscript: "",
      text: "The premium is including taxes and for Bronze Variant, for a 25-year-old individual living in Delhi.",
    },
    {
      superscript: "",
      text: "The premium is including taxes and for Gold Variant, for a 65-year-old individual living in Delhi.",
    },
  ],
}